import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    /**
     * Récupère la liste des utilisateurs sans driverProfilId (non liés à Yandex)
     * @param {Object} params - { page, limit, q, sort }
     */
    getUsersWithoutDriver: async (params = {}) => {
        // Filtrer les valeurs undefined/null
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `/admin/sync/users-without-driver${queryString ? '?' + queryString : ''}`;
        console.log('[SYNC Service] Calling:', url);
        return exeRequest(url, "GET");
    },

    /**
     * Récupère les statistiques de synchronisation
     * @param {string} cityId - ID de la ville (optionnel)
     */
    getStats: async (cityId = null) => {
        const params = cityId ? `?cityId=${cityId}` : '';
        return exeRequest(`/admin/sync/stats${params}`, "GET");
    },

    /**
     * Lie un utilisateur Tigoon à un profil Yandex
     * @param {Object} data - { userId, driverProfilId }
     */
    linkDriver: async (data) => exeRequest(`/admin/sync/link-driver`, "POST", data),

    /**
     * Synchronise manuellement un chauffeur avec son véhicule (endpoint existant)
     * @param {Object} data - { driverProfilId }
     */
    manualDriverSync: async (data) => exeRequest(`/admin/synchronize/manual-driver`, "POST", data),

    // ==================== VEHICULES ====================

    /**
     * Récupère la liste des véhicules Yandex non présents dans Tigoon
     * @param {Object} params - { page, limit, q }
     */
    getVehiclesNotInTigoon: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `/admin/sync/vehicles-not-in-tigoon${queryString ? '?' + queryString : ''}`;
        return exeRequest(url, "GET");
    },

    /**
     * Récupère les statistiques de synchronisation des véhicules
     * @param {string} cityId - ID de la ville (optionnel)
     */
    getVehicleStats: async (cityId = null) => {
        const params = cityId ? `?cityId=${cityId}` : '';
        return exeRequest(`/admin/sync/vehicles-stats${params}`, "GET");
    },

    /**
     * Synchronise un véhicule Yandex vers Tigoon
     * @param {Object} data - { carId }
     */
    syncVehicle: async (data) => exeRequest(`/admin/sync/sync-vehicle`, "POST", data),

    /**
     * Synchronise tous les véhicules Yandex manquants vers Tigoon
     */
    syncAllVehicles: async (cityId) => exeRequest(`/admin/sync/sync-all-vehicles`, "POST", { cityId }),

    // ==================== ANCIENS CHAUFFEURS (Yandex -> Tigoon) ====================

    /**
     * Récupère la liste des chauffeurs Yandex non présents dans Tigoon
     * @param {Object} params - { page, limit, q }
     */
    getDriversNotInTigoon: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `/admin/sync/drivers-not-in-tigoon${queryString ? '?' + queryString : ''}`;
        return exeRequest(url, "GET");
    },

    /**
     * Récupère les statistiques de synchronisation des chauffeurs Yandex
     * @param {string} cityId - ID de la ville (optionnel)
     */
    getDriversYandexStats: async (cityId = null) => {
        const params = cityId ? `?cityId=${cityId}` : '';
        return exeRequest(`/admin/sync/drivers-yandex-stats${params}`, "GET");
    },

    /**
     * Synchronise un chauffeur Yandex vers Tigoon (avec 1000 points)
     * @param {Object} data - { driverProfilId, cityId }
     */
    syncDriverFromYandex: async (data) => exeRequest(`/admin/sync/sync-driver-from-yandex`, "POST", data),

    /**
     * Synchronise tous les chauffeurs Yandex manquants vers Tigoon
     * @param {string} cityId - ID de la ville (requis pour utiliser les bons credentials Yandex)
     */
    syncAllDriversFromYandex: async (cityId) => exeRequest(`/admin/sync/sync-all-drivers-from-yandex`, "POST", { cityId }),

    // ==================== CACHE YANDEX ====================

    /**
     * Récupère les statistiques du cache Yandex
     * @param {string} cityId - ID de la ville (optionnel)
     */
    getCacheStats: async (cityId = null) => {
        const params = cityId ? `?cityId=${cityId}` : '';
        return exeRequest(`/admin/sync/cache/stats${params}`, "GET");
    },

    /**
     * Rafraîchit le cache Yandex pour une ville
     * @param {string} cityId - ID de la ville
     */
    refreshCache: async (cityId) => exeRequest(`/admin/sync/cache/refresh`, "POST", { cityId }),

    /**
     * Rafraîchit le cache Yandex pour toutes les villes
     */
    refreshAllCache: async () => exeRequest(`/admin/sync/cache/refresh-all`, "POST", {}),

    /**
     * Récupère la liste des chauffeurs dans le cache Yandex
     * @param {Object} params - { page, limit, q, cityId, isLinkedToTigoon }
     */
    getCacheDrivers: async (params = {}) => {
        const cleanParams = {};
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `/admin/sync/cache/list${queryString ? '?' + queryString : ''}`;
        return exeRequest(url, "GET");
    },

    /**
     * Supprime un utilisateur (chauffeur non lié)
     * @param {string} userId - ID de l'utilisateur à supprimer
     */
    deleteUser: async (userId) => exeRequest(`/admin/users/${userId}`, "DELETE"),
};
